import { createApp } from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import "./assets/styles/index.scss";
import "aos/dist/aos.css";
import "aos/dist/aos.js";
import { Vue } from "vue-class-component";

createApp(App).mount("#app");
